export default __webpack_public_path__ + "static/char-v-40-zh-Hant-a6b51331a49d9af492e32717ffad2bc6.mp4";